import React, { Component } from 'react';
import store from '../store';
import moment from 'moment-jalaali'
import DatePicker from 'react-datepicker2';
class About extends Component {
    constructor(props) {
        super(props);
        this.state = { value: moment() };
    }
    async readFile(file) {
        //alert("hiiiiiiii");
        //console.log("dsfsdfsdfsdf");
        const response = await fetch(file)
        const text = await response.text();
        console.log("txt1: ", response);
        console.log("txt: ", text);
        console.log("json", JSON.parse(text).ver);
        return "";
    }
    render() {

        console.log("about........................", store);
        this.readFile("./config.txt");
        //store.dispatch({ type: 'ABOUT' });
        store.dispatch({ type: '/about' });
        return (

            <div className="Header">
                <button onClick={() => store.dispatch({ type: 'ABOUT' })}>injaaaaaaaa</button>
                <h1>about:{store.getState()}</h1>
                <h1>About ..1111...........</h1>
                <DatePicker
                    onChange={value => this.setState({ value })}
                    value={this.state.value}
                />
            </div>
        );
    }
}
export default (About);


// WEBPACK FOOTER //
// ./src/pages/About.js